
const serverRoutes = {
    login: "/api/client/onboarding/login",
    refresh: "/api/auth/admin/refresh",
    testimonials: "/api/testimonial/list",
    companies: "/api/companySearch",
    productSearch: "/api/productSearch",
    Indystry: "/api/common/industry",
    professionals: "/api/client/professional/list",
    professionalProfile: "/api/client/professional/details",
    portfolioProjects: "/api/client/professional/portfolio",
    professionalServices: "/api/client/professional/services",
    products: "/api/products/search",

    userInfo: "/api/client/onboarding/userInfo",
    reviewInfo: "/api/client/onboarding/company/verify/details",

    state: "/api/common/state?code=101",
    industryList: "/api/common/industry/list",
    getIndutryData: "/api/common/industry/get",


    //ECOM
    getProducts: "/api/ecom/products",
    getcategoryList: "/api/ecom/categories",





}

const clientRoutes = {
    captureLead: "/backend/company/lead/capture",
    companySearch: "/backend/companySearch",
    productSearch: "/backend/products/search",
    applyJob: "/backend/client/apply/job",
    createAccount: "/backend/client/onboarding/createAccount",
    verifyEmail: "/backend/client/onboarding/email/verify",
    resendOTP: "/backend/client/onboarding/email/resend",
    submitProfessionalOnboarding: "/backend/client/onboarding/professional/update",
    verifyInviteCode: "/backend/client/onboarding/invite/verify",
    updateCompany: "/backend/client/onboarding/company/update",
    submitToReview: "/backend/client/onboarding/company/verify",
    requestSSOToken: "/backend/client/onboarding/sso",

    countryList: "/backend/common/countries",
    stateList: "/backend/common/state",
    cityList: "/backend/common/city",
    industryList: "/backend/admin/company/industry",
    addTocart: "/backend/ecom/cart/add",
    incrementCartQuanity: "/backend/ecom/cart/increase",
    descrementCartQuanity: "/backend/ecom/cart/decrease",
    removeCartItem: "/backend/ecom/cart/remove",
    cartList: "/backend/ecom/cart/list",
    saveCartLocation: "/backend/ecom/cart/location",
    categoryList: "/backend/ecom/categories",
    placeOrder: "/backend/ecom/order/place",
    createRazorpayOrder: "/backend/ecom/order/razorpay/create",
    verifyRazorpayPayment: "/backend/ecom/order/razorpay/verify",
    calculateDelieryCharge: "/backend/ecom/checkout/delivery-charge",
    orderStatus: (orderId: string) => `/backend/ecom/order/status/${orderId}`,
    availableDeliverySlots: "/backend/ecom/delivery-slot/available",
    portfolioList: "/backend/client/professional/portfolio/list",
    serviceList: "/backend/client/professional/service/list",
    connectRequest: "/backend/client/professional/connectRequest",
    serviceRequest: "/backend/client/professional/serviceRequest",
    testimonials: "/backend/testimonial/list",
}

export const apiRoutes = {
    serverRoutes,
    clientRoutes
}